import React from 'react';

import {Button, Dropdown, Icon, Label, MenuListItem, Text} from '@albert-io/atomic';
import classNames from 'classnames';

import type {DropdownOption} from './schoolAssociation.types';

interface FormDropdownProps {
  label: string;
  value: string;
  placeholder: string;
  options: DropdownOption[];
  onChange: (next: string) => void;
  disabled?: boolean;
  testId?: string;
}

export default function FormDropdown({
  label,
  value,
  placeholder,
  options,
  onChange,
  disabled,
  testId
}: FormDropdownProps) {
  const selected = options.find((o) => o.value === value);

  return (
    <div className='flex flex-col'>
      <Label>{label}</Label>
      <Dropdown
        fillWrapper
        wrapperClassName='mt-x1 w-full'
        trayClassName='w-full my-x0-half!'
        contentClassName='!max-w-none'
        trigger={
          <Button
            variant='outlined'
            disabled={disabled}
            data-testid={testId}
            className='flex w-full items-center! justify-between gap-x2 background-primary! px-x1-half! py-x1! aria-expanded:ring-2! aria-expanded:ring-border-selected! aria-expanded:ring-inset!'
          >
            <Text
              color={selected ? 'primary' : 'tertiary'}
              className='truncate text-left font-normal!'
            >
              {selected?.label ?? placeholder}
            </Text>
            <Icon icon='caret-down' color='secondary' />
          </Button>
        }
      >
        {({close}: {close: () => void}) => (
          <div className='flex max-h-[320px] flex-col gap-y-x0-quarter overflow-y-auto p-x1'>
            {options.map((option) => {
              const isSelected = value === option.value;
              return (
                <MenuListItem
                  key={option.value}
                  className={classNames(
                    'h-[37px] w-full shrink-0 items-center! justify-between! px-x1-half!',
                    {'background-info-subtle': isSelected}
                  )}
                  onClick={() => {
                    onChange(option.value);
                    close();
                  }}
                >
                  <Text>{option.label}</Text>
                  {isSelected && <Icon icon='check' color='info' aria-hidden />}
                </MenuListItem>
              );
            })}
          </div>
        )}
      </Dropdown>
    </div>
  );
}
